/**
 * Sesiones de evento cuyo mensaje de visibilidad reducida debe indicar además
 * audición reducida. El resto de sesiones (y cualquier caso dudoso) mantiene el
 * mensaje base de siempre.
 *
 * Se filtra por sesión y no por evento porque un mismo evento puede tener
 * varias sesiones y solo algunas deben mostrar el mensaje.
 */
export const SESIONES_AUDICION_REDUCIDA = [21310, 21311, 21312, 21313, 21314, 21316, 21319, 21320];

/**
 * Indica si una sesión debe mostrar el mensaje de visibilidad y audición
 * reducida. Acepta id numérico o string (params de ruta). Nunca lanza: ante
 * cualquier entrada inválida devuelve `false` (mensaje base).
 */
export function esSesionAudicionReducida(sesionId) {
    try {
        const id = Number(sesionId);

        return Number.isFinite(id) && SESIONES_AUDICION_REDUCIDA.includes(id);
    } catch (error) {
        return false;
    }
}

/**
 * Devuelve la clave i18n a usar para una sesión. Solo usa la variante
 * `_audicion` si la sesión está en la lista Y esa traducción existe realmente;
 * en cualquier otro caso devuelve `baseKey` (mensaje de siempre).
 *
 * @param {string}    baseKey   clave base, p. ej. 'visibilidad_reducida.nombre'
 * @param {*}         sesionId  id de la sesión (número o string)
 * @param {Function}  [te]      `$te` de vue-i18n. Debe pasarse LIGADO
 *                              (p. ej. `(k) => this.$te(k)`), porque vue-i18n
 *                              lo invoca como método.
 */
export function claveVisibilidad(baseKey, sesionId, te) {
    try {
        if (!esSesionAudicionReducida(sesionId)) {
            return baseKey;
        }

        const candidata = `${baseKey}_audicion`;

        return typeof te === 'function' && !te(candidata) ? baseKey : candidata;
    } catch (error) {
        return baseKey;
    }
}
